import { render, staticRenderFns } from "./HelloWorldPage5.vue?vue&type=template&id=6b4c641a&"
import script from "./HelloWorldPage5.vue?vue&type=script&lang=ts&"
export * from "./HelloWorldPage5.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VSimpleCheckbox,VTabItem,VTabsItems})
